module.exports = __webpack_public_path__ + "img/nhom-hoc-lieu-2.f971f2cf.svg";